export default function floorFigure(figure: string, decimals: number) {
  // if (!decimals) decimals = 2
  const d: number = Math.pow(10, decimals)
  const result = (parseInt((+figure * d).toString()) / d)
  // const result = (Math.round((+figure * d)) / d)
  return result.toFixed(decimals)
}